import React, { useEffect, useRef } from 'react';

export const ScrollToBottom = () => {
  const ref = useRef(null);

  const scrollToBottom = () => {
    ref.current.scrollIntoView({ behavior: 'auto', block: 'nearest' });
  };

  useEffect(() => {
    scrollToBottom();
  });

  return <div className="scroll-to-bottom" style={{ float: 'left', clear: 'both' }} ref={ref} />;
};

export default ScrollToBottom;
